import { useEffect, useState } from 'react'

type UseScrollFoldOptions = {
  threshold?: number
  onScroll?: () => void
}

export const useScrollFold = ({ threshold = 680, onScroll }: UseScrollFoldOptions = {}) => {
  const [fold, setFold] = useState(false)

  useEffect(() => {
    let ticking = false

    const handleScroll = () => {
      const scrollY = window.scrollY
      setFold(scrollY > threshold)

      if (onScroll) {
        onScroll()
      }
    }

    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll()
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener('scroll', throttledScroll, { passive: true })
    handleScroll()

    return () => {
      window.removeEventListener('scroll', throttledScroll)
    }
  }, [threshold, onScroll])

  return fold
}
